import React, { useEffect } from 'react';

import { NOTIFICATION_MESSAGES } from 'constants/NotificationMessages';

export function ErrorDisplay({ error: errorProp }: { error: any }) {
  // eslint-disable-next-line no-console
  useEffect(() => console.error('error', errorProp), [errorProp]);

  let error = errorProp?.message || JSON.stringify(errorProp, null, 2);

  if (/UNPREDICTABLE_GAS_LIMIT/.test(error.toString())) {
    error = 'Insufficient ETH to pay gas fee.';
  }
  if (errorProp?.code === 4001) {
    error = NOTIFICATION_MESSAGES.error.rejectedTransaction;
  }

  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <>{`${error}`}</>;
}
